<template>
  <div class="position-relative">
    <div class="overflow">
      <table class="v-datatable v-table theme--light" ref="table">
        <thead>
          <tr>
            <!-- make more generic, if text, show item.text -->
            <th class="column" v-for="(item, ind) in sortedHeaders" @contextmenu.prevent="showContextMenu($event, item)" :key="ind">{{ item.text }}</th>
          </tr>
          <tr class="v-datatable__progress">
            <th :colspan="headers.length" class="column">
              <div role="progressbar" aria-valuemin="0" aria-valuemax="100" class="v-progress-linear" style="height: 2px" v-if="loading">
                <div class="v-progress-linear__background primary" style="height: 2px; opacity: 0.3; width: 100%"></div>
                <div class="v-progress-linear__bar">
                  <div class="v-progress-linear__bar__indeterminate v-progress-linear__bar__indeterminate--active">
                    <div class="v-progress-linear__bar__indeterminate long primary"></div>
                    <div class="v-progress-linear__bar__indeterminate short primary"></div>
                  </div>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, ind) in items" :key="ind">
            <!-- make more generic, v-if to display link or text -->
            <!-- <td> -->
              <!-- check for an object, if it is create router link with obj as params. use third property to determine tag, should be routerlink here
              <router-link :to="{ name: 'hcpProfile', params: { runId: 1, cohortId:1,  npi: item.npi } }">Profile</router-link>
            </td> -->
            <!-- <template > -->
              <td v-for="(header, ind1) in sortedHeaders" :key="ind1">
                <template v-if="header.hasOwnProperty('link') == false || header.link == false" >{{ header.valueFnc(item) }}</template> 
                <!-- <template >{{ header.valueFnc(item) }}</template>  -->

                <template v-else ><router-link :to="{ name: header.routeObj.route, params: header.routeParamsFnc(item) }">{{ header.text }}</router-link></template>
              </td>
              
            <!-- </template> -->
          </tr>
        </tbody>
      </table>
    </div>
    <table class="v-datatable v-table theme--light left-part" :style="{ width: `${freezedWidth}px` }" v-if="freezedHeaders.length">
      <thead>
        <tr>
          <th class="column" v-for="(item, ind) in freezedHeaders" @contextmenu.prevent="showContextMenu($event, item)" :key="ind">{{ item.text }}*</th>
        </tr>
        <tr class="v-datatable__progress">
          <th colspan="6" class="column"></th>
        </tr>
      </thead>
      <colgroup>
        <col v-for="(column, colInd) in columnWidths.filter((_, ind) => ind < freezedHeaders.length)" :style="{ width: `${column}px` }" :key="colInd" />
      </colgroup>
      <tbody>
        <tr v-for="(item, ind) in items" :style="{ height: `${rowHeights[ind]}px` }" :key="ind">
          <td v-for="(header, ind1) in freezedHeaders" :key="ind1">{{ header.valueFnc(item) }}</td>
        </tr>
      </tbody>
    </table>

    <!-- Right click menu -->
    <hvh-context-menu :event="contextMenuEvent">
      <li @click="toggleFrozen(contextMenuItem, true)" v-if="!frozenColumns.includes((contextMenuItem || {}).text)">
        <label>Freeze</label>
      </li>
      <li @click="toggleFrozen(contextMenuItem, false)" v-else>
        <label>Unfreeze</label>
      </li>
    </hvh-context-menu>
  </div>
</template>

<script>
export default {
  props: ['headers', 'items', 'loading'],
  data() {
    return {
      columnWidths: [],
      rowHeights: [],
      contextMenuEvent: null,
      contextMenuItem: null,
      frozenColumns: [],
    };
  },
  computed: {
    freezedHeaders() {
      return this.headers.filter(f => this.frozenColumns.includes(f.text));
    },
    sortedHeaders() {
      return [...this.freezedHeaders, ...this.headers.filter(f => !this.freezedHeaders.includes(f))];
    },
    freezedWidth() {
      return this.columnWidths.filter((_, ind) => ind < this.freezedHeaders.length).sum();
    },
  },
  methods: {
    calculateColumnWidths() {
      var columnWidths = Array.from(this.$refs.table.tHead.children[0].children).map(f => f.offsetWidth);
      if (this.columnWidths.join(',') !== columnWidths.join(','))
        this.columnWidths = columnWidths;

      var rowHeights = Array.from(this.$refs.table.tBodies[0].children).map(f => f.offsetHeight);
      if (this.rowHeights.join(',') !== rowHeights.join(','))
        this.rowHeights = rowHeights;
    },
    showContextMenu(event, item) {
      this.contextMenuEvent = event;
      this.contextMenuItem = item;
    },
    toggleFrozen(item, event) {
      // var shouldAdd = !this.frozenColumns.includes(item.text);

      var headerItems = this.headers.map(f => f.text);
      this.frozenColumns = [
        ...this.frozenColumns.filter(f => f !== item.text && headerItems.includes(f)),
        ...(event ? [item.text] : []),
      ];
    },
  },
  updated() {
    this.calculateColumnWidths();
  },
  mounted() {
    this.calculateColumnWidths();

    window.addEventListener('resize', this.calculateColumnWidths);
  },
  destroyed() {
    window.removeEventListener('resize', this.calculateColumnWidths);
  },
}
</script>

<style lang="scss" scoped>
.position-relative {
  position: relative;

  .overflow {
    overflow-x: auto;
  }

  .left-part {
    position: absolute;
    top: 0;
    left: 0;
    border-right: 2px lightgrey solid;
    // background-color: lightgrey;
  }
}
</style>
